<template>
  <v-ons-page modifier="white" @init="initChartCours()">

    <v-ons-toolbar class="toolbar--noshadow toolbar--noborder" modifier="perfhome">
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">
        Cours {{ coursLabel }} - {{ cultLabel }}
      </div>
    </v-ons-toolbar>

    <div class="content">

      <section class="content--perfcours" :style="{ height: coursJour[echeanceDisplay] ? '191px' : '100%' }">

        <v-ons-toolbar-button v-if="echeanceList.length" modifier="perfrecolte" @click="showEcheances = true">
          Éch {{ getLabelEcheance(echeanceDisplay) }}
          <v-ons-icon icon="angle-down"></v-ons-icon>
        </v-ons-toolbar-button>
        <span v-else>
          {{ referentiel.cours[coursName].libelle_cours }},
          {{ coursName == 'soja' ? getLabelEcheance(data.cours[coursName].echeances[campagne]) : referentiel.cours[coursName].libelle_echeance }}
        </span>

        <template v-if="coursJour[echeanceDisplay]">
          <div v-if="chartIndex == -1" class="content--perfcours__infos">
            <h2>
              {{ coursJour[echeanceDisplay].cours.toLocaleString('fr', { minimumFractionDigits: 2 }) }}
              <small>€/t</small>
            </h2>
            <span v-if="echeanceList.length">
              Euronext -
              {{ getCoursDate(coursJour[echeanceDisplay].date, coursJour[echeanceDisplay].isExpire, coursJour[echeanceDisplay].isLiveDiff ? live.date : 0, now) }}
            </span>
            <span v-else>
              {{ coursJour[echeanceDisplay].date }}
            </span>
            <ons-row v-if="! coursJour[echeanceDisplay].isExpire">
              <ons-col>
                <ons-row v-if="coursJour[echeanceDisplay].max">
                  <ons-col>
                    Clôture
                    <span>
                      {{ coursJour[echeanceDisplay].cloture.toLocaleString('fr', { minimumFractionDigits: 2 }) }} €/t
                    </span>
                  </ons-col>
                </ons-row>
                <ons-row>
                  <ons-col>
                    Variation
                    <span>
                      {{ formatCoursDiff(coursJour[echeanceDisplay].diff) }} €/t
                    </span>
                  </ons-col>
                </ons-row>
              </ons-col>
              <ons-col>
                <ons-row v-if="coursJour[echeanceDisplay].max">
                  <ons-col>
                    Max jour
                    <span>
                      {{ coursJour[echeanceDisplay].max.toLocaleString('fr', { minimumFractionDigits: 2 }) }} €/t
                    </span>
                  </ons-col>
                </ons-row>
                <ons-row v-if="coursJour[echeanceDisplay].max">
                  <ons-col>
                    Min jour
                    <span>
                      {{ coursJour[echeanceDisplay].min.toLocaleString('fr', { minimumFractionDigits: 2 }) }} €/t
                    </span>
                  </ons-col>
                </ons-row>
              </ons-col>
            </ons-row>
          </div>
          <div v-else class="content--perfcours__data">
            <span>{{ formatDate(chartData[chartIndex].x) }}</span>
            <h2>
              {{ chartData[chartIndex].y.toLocaleString('fr', { minimumFractionDigits: 2 }) }}
              <small>€/t</small>
            </h2>
          </div>
        </template>

        <div v-else class="content--perfalert__empty" style="height: calc(100% - 52px)">
          <section>
            <img src="../assets/imgs/icon_wait_bg@2x.png" />
            <h3>Revenez plus tard !</h3>
            <p>
              Le cours {{ referentiel.cours[coursName].libelle_cours }} apparaîtra ici quand il
              sera disponible pour {{ echeanceList.length ? "l'échéance " + getLabelEcheance(echeanceDisplay) : echeanceDisplay }}.
            </p>
          </section>
        </div>

      </section>

      <canvas id="coursChart" width="375" height="375"></canvas>

      <!-- v-show="rangeStart < 4" -->
      <v-ons-segment v-if="coursJour[echeanceDisplay]" modifier="perfarmer" :index.sync="rangeIndex" style="width: 100%">
        <button v-for="(infos, index) in rangeInfos" :disabled="index < rangeStart" :key="index">
          {{ infos.label }}
        </button>
      </v-ons-segment>

    </div>

    <v-ons-action-sheet :modifier="$mdModifier" :visible.sync="showEcheances" cancelable title="Échéances">
      <v-ons-action-sheet-button :modifier="$mdModifier" v-for="(coursItem, echeance) in coursJour" :key="echeance"
                                 @click="switchEcheance(echeance)" :style="{ 'font-weight': echeance == echeanceDisplay ? 'bold' : 'normal' }">
        {{ getLabelEcheance(echeance) }}
      </v-ons-action-sheet-button>
      <v-ons-action-sheet-button v-if="! $md" @click="showEcheances = false">Fermer</v-ons-action-sheet-button>
    </v-ons-action-sheet>

  </v-ons-page>
</template>

<script>
import mixinsCours from '../mixins/cours.js';
import mixinsGraph from '../mixins/graph.js';

import { store } from '../store.js';

export default {
  mixins: [mixinsCours, mixinsGraph],
  props: ['pageStack'],
  data() {
    return {
      refCulture: '',
      refDestination: '',
      echeanceInit: null,
      echeanceDisplay: null,
      showEcheances: false,
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    campagne() {
      return this.user.campagne;
    },
    strategie() {
      return this.user.ventes[this.refCulture][this.refDestination];
    },
    coursName() {
      return this.referentiel.cultures[this.refCulture].destinations[this.refDestination].cours;
    },
    live() {
      return this.data.live;
    },
    now() {
      return this.data.now;
    },
    echeanceCurrent() {
      return this.data.cours[this.coursName].current;
    },
    echeanceList() {
      return this.getEcheanceList(this.coursName, this.campagne);
    },
    echeanceDefault() {
      if(this.strategie.objectif && ! this.strategie.negoce && this.strategie.echeance){
        return this.strategie.echeance;
      } else {
        return this.getEcheanceDefault(this.campagne, this.echeanceCurrent, this.echeanceList);
      }
    },
    coursJour() {
      return this.getCoursJour(this.coursName, this.data.cours[this.coursName], this.live, this.echeanceList, this.echeanceDefault);
    },
    coursDataDisplay() {
      var coursData = this.data.cours[this.coursName];
      var coursDataDisplay = coursData[this.echeanceDisplay];
      if (!this.echeanceList.length && this.coursName != 'soja') {
        if (coursData[this.echeanceDisplay - 1]) {
          coursDataDisplay = coursData[this.echeanceDisplay - 1].concat(coursDataDisplay);
        }
        if (coursData[this.echeanceDisplay - 2]) {
          coursDataDisplay = coursData[this.echeanceDisplay - 2].concat(coursDataDisplay);
        }
      }
      return coursDataDisplay;
    },
    coursObjectif() {
      if (this.strategie.negoce) {
        return '';
      } else {
        return this.getCoursFromEffectif(this.strategie.objectif,
          this.referentiel.cultures[this.refCulture].destinations[this.refDestination],
          this.strategie.diff
        );
      }
    },
    coursLabel() {
      if (this.referentiel.cours[this.coursName].echeances) {
        return 'Euronext';
      } else if (this.coursName == 'soja') {
        return 'Chicago';
      } else {
        return 'physique';
      }
    }
  },
  watch: {
    echeanceDisplay(value, oldValue) {
      this.setRange(this.coursDataDisplay);
      if (oldValue) {
        this.initChartCours();
      }
    },
    rangeIndex() {
      this.initChartCours();
    }
  },
  methods: {
    initChartCours() {
      if (!this.coursDataDisplay) {
        if (this.chart) {
          this.chart.destroy();
          this.$el.querySelector('#coursChart').height = 0;
        }
        return;
      }
      this.initChart(this.coursDataDisplay, this.echeanceDisplay == this.echeanceDefault ? this.coursObjectif : '');
    },
    switchEcheance(echeance) {
      this.echeanceDisplay = echeance;
      this.showEcheances = false;
    }
  },
  created() {
    this.echeanceDisplay = this.echeanceInit ? this.echeanceInit : this.echeanceDefault; // trigger watch echeanceDisplay
  }
}
</script>

<style>
.content--perfcours {
  background-color: var(--perfarmer-gris-bleu-light);
  padding: 15px 0;
  text-align: center;
  box-sizing: border-box;
}
.content--perfcours > span {
  font-weight: 500;
  font-size: 14px;
  color: var(--perfarmer-gris-normal);
}
.content--perfcours__infos {
  background-color: white;
  width: 310px;
  margin: 15px auto 0;
  padding: 15px 0;
  border-radius: 6px;
}
.content--perfcours__infos h2 {
  font-weight: 500;
  font-size: 28px;
  height: 30px;
  margin: 0;
}
.content--perfcours__infos span {
  color: var(--perfarmer-gris-normal);
  font-size: 12px;
}
.content--perfcours__infos > ons-row {
  padding: 15px 20px 0;
  font-size: 12px;
  color: var(--perfarmer-gris-dark);
  text-align: left;
}
.content--perfcours__infos > ons-row ons-row ons-col span {
  color: black;
  float: right;
}
.content--perfcours__infos > ons-row > ons-col {
  margin-right: 12px;
}
.content--perfcours__infos > ons-row > ons-col + ons-col {
  margin-left: 12px;
}
.content--perfcours__infos ons-row + ons-row {
  margin-top: 5px;
}
.content--perfcours__data {
  background-color: var(--perfarmer-vert);
  color: white;
  width: 230px;
  border-radius: 6px;
  padding: 20px 0;
  margin: 28px auto 0;
  font-size: 20px;
}
.content--perfcours__data h2 {
  font-size: 28px;
  line-height: 42px;
  margin: 5px 0 0;
}
#coursChart {
  background-color: var(--perfarmer-gris-bleu-light);
}
.segment--perfarmer__button {
  color: var(--perfarmer-gris-very-dark);
}
.action-sheet {
  max-height: calc(100% - 20px);
  overflow: auto;
}
</style>